import { PATH_ROOT } from 'constants/api'
import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { selectSessionStatus } from 'store/selectors'
import { SESSION_STATUS } from 'store/sessionSlice'

const RequiredAuth = () => {
    const sessionStatus = useSelector(selectSessionStatus)

    if (sessionStatus === SESSION_STATUS.BOOTSTRAPPING) return null

    return (
        <React.Fragment>
            {
                sessionStatus === SESSION_STATUS.AUTHENTICATED ?
                    <Outlet /> :
                    <Navigate to={`${PATH_ROOT}/auth/login`} />
            }
        </React.Fragment>
    )
}

export default RequiredAuth
